<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>
                {{ $route.name == "document-add" ? "Add" : "Edit" }} Document
              </h2>
            </div>
            <div class="body">
              <form @submit.prevent="passes(documentSubmit)" id="basic-form">
                <div class="body">
                  <ValidationProvider
                    name="title"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div
                      class="form-group"
                      :class="{
                        errors: errors.length && !document.title,
                        success: document.title,
                      }"
                    >
                      <span class="float-label">
                        <input
                          type="text"
                          v-model="document.title"
                          class="form-control"
                          placeholder="Document Title"
                        />
                        <label for="cms" class="control-label">
                          Document Title*
                        </label>
                        <div class="line"></div>
                        <i
                          class="fa fa-times"
                          v-if="errors.length && !document.title"
                        ></i>
                        <i class="fa fa-check" v-if="document.title"></i>
                      </span>
                    </div>
                  </ValidationProvider>
                  <div class="form-group">
                    <span class="float-label">
                      <div class="custom-file">
                        <input
                          type="file"
                          class="custom-file-input"
                          id="inputGroupFile01"
                          @change="upload"
                        />
                        <label class="custom-file-label" for="inputGroupFile01">
                          Upload Document
                        </label>
                      </div>
                      <div class="ml-2">
                        {{ document.file.name }}
                      </div>
                    </span>
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center w-25"
                  >
                    <label class="mb-0" for="customSwitchstatus">Status</label>
                    <div class="custom-switch success-error-bg">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        id="customSwitchstatus"
                        v-model="document.status"
                      />
                      <label
                        class="custom-switch-label pr-4 pl-5"
                        for="customSwitchstatus"
                      >
                        <span class="custom-switch-text1">Active</span>
                        <span class="custom-switch-text2">InActive</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
export default {
  name: "AddOrEditDocument",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      document: {
        title: "",
        file: "",
        status: true,
      },
    };
  },
  methods: {
    upload(e) {
      if (e.target.files.length > 0) {
        let file = e.target.files[0];
        this.document.file = file;
      }
    },
    documentSubmit() {
      console.log(this.document);
    },
  },
  mounted() {
    if (this.$route.name == "document-edit") {
      this.document = {
        title: "Top",
        file: { name: "myfile.txt" },
        status: true,
      };
    }
  },
};
</script>
